import { useState, useEffect } from 'react';
import ExternalSignIn from './external-sign-in';
import useUserData, { getPStoreID, useUserReceived } from '../../../hooks/useUserData';
import { loggedOutProps, generalStoreProps, softSignInProps } from './external-sign-in.types.js';

export default props => {
    const userReceived = useUserReceived();
    const { userData } = useUserData();
    const pStoreID = getPStoreID(userData);
    const { profileData } = userData || {};
    const { personData } = profileData || {};
    const { isLoggedIn, isSecureLinkUser, userType } = personData || {};
    const [params, setParams] = useState({});
    const { softsignin } = props;

    useEffect(() => {
        if (userReceived) {
            const signUpURL =
                window.location.origin +
                '/us-en/shop/PrivateRegister?storeId=10151&catalogId=10051&pStoreID=' +
                pStoreID;
            const learnMoreURL = pStoreID
                ? window.location.origin + '/us-en/shop/cv/welcome-' + pStoreID.replaceAll('_', '-')
                : undefined;
            const loginURL = profileData.logonUrl;
            const name = personData?.firstname;
            if (softsignin) {
                setParams({ data: softSignInProps(name, loginURL, learnMoreURL) });
            } else {
                if (!isLoggedIn || (isSecureLinkUser && userType === 'G')) {
                    setParams({ data: loggedOutProps(loginURL, signUpURL, learnMoreURL) });
                } else if (
                    isLoggedIn &&
                    ((isSecureLinkUser && userType === 'R' && personData.custSeg === 'CG_gs') ||
                        personData.custSeg === 'CG_gs')
                ) {
                    setParams({ data: generalStoreProps(name, signUpURL, learnMoreURL) });
                }
            }
        }
    }, [userReceived, softsignin]);

    return <ExternalSignIn {...params} />;
};
